
const TypesIcon = ({ color = "var(--primary-color)", width, height, ...props}) => (
    <svg    
        viewBox="0 0 20 20"
        width={width || 20}
        height={height || 20}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        {...props}
    >
        <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity={0.72}
        strokeWidth={1.5}
        d="M9.166 6.114H3.331a.834.834 0 0 1-.834-.834V3.613c0-.46.373-.834.834-.834h5.835"
        />
        <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity={0.72}
        strokeWidth={1.5}
        d="M4.373 12.366h-1.25a.626.626 0 0 1-.626-.625v-1.25c0-.346.28-.626.625-.626h1.25c.346 0 .626.28.626.625v1.25c0 .346-.28.626-.625.626Z"
        clipRule="evenodd"
        />
        <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity={0.72}
        strokeWidth={1.5}
        d="M7.684 11.116h9.82"
        />
        <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity={0.72}
        strokeWidth={1.5}
        d="M4.373 17.785h-1.25a.625.625 0 0 1-.626-.625v-1.25c0-.346.28-.626.625-.626h1.25c.346 0 .626.28.626.625v1.25c0 .346-.28.626-.625.626Z"
        clipRule="evenodd"
        />
        <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity={0.72}
        strokeWidth={1.5}
        d="M7.684 16.535h9.82"
        />
        <circle
        cx={14.168}
        cy={4.446}
        r={2.501}
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity={0.72}
        strokeWidth={1.5}
        />
        <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity={0.72}
        strokeWidth={1.5}
        d="m17.503 7.781-1.566-1.567"
        />
    </svg>

)

export default TypesIcon
